// extracted by mini-css-extract-plugin
export default {"ActiveSuggestionsInfo":"ActiveSuggestionsInfo-module-e3e219181815deb16711"};